import { TitleDepth, titleStore } from '@state/titleContext';
import { useContext, useEffect, type ReactNode } from 'react';

export interface TitleProps {
  title?: string;
  children?: ReactNode;
}

export default function Title({ title, children }: TitleProps) {
  const depth = useContext(TitleDepth);

  useEffect(() => {
    if (title === undefined) {
      return;
    }

    const item = { depth, title };
    titleStore.add(item);

    return () => {
      titleStore.delete(item);
    };
  }, [depth, title]);

  return <TitleDepth.Provider value={depth + 1}>{children}</TitleDepth.Provider>;
}
